export default "__VITE_ASSET__Cab9A$Sa__"